export class MetricsComparisonDto{
  constructor(public metric_query_name: string,
              public metric_pretty_name: string,
              public message?: string) {
  }
}
